import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { GET_PROFESSIONAL_SERVICE, UPDATE_PROFESSIONAL_SERVICE } from '../../graphql/professional-services';
import ProfessionalServiceForm from './ProfessionalServiceForm';

const EditProfessionalService = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, loading: loadingQuery, error: queryError } = useQuery(GET_PROFESSIONAL_SERVICE, {
    variables: { id },
    fetchPolicy: 'network-only'
  });

  const [updateService, { loading: saving, error: saveError }] = useMutation(UPDATE_PROFESSIONAL_SERVICE, {
    onCompleted: () => navigate(`/sales/professional-services/${id}`),
    onError: (err) => console.error('Error updating professional service:', err)
  });

  const handleSubmit = (inputData) => {
    updateService({ variables: { id, inputData } });
  };

  if (loadingQuery) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (queryError || !data?.professionalService) {
    return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        {queryError ? queryError.message : 'Professional service not found'}
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-semibold flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit {data.professionalService.companyName}
        </h1>
        <Link to={`/sales/professional-services/${id}`} className="flex items-center text-blue-600 hover:text-blue-800">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back
        </Link>
      </div>

      {saveError && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {saveError.message}
        </div>
      )}

      <div className="bg-white shadow rounded-lg p-6">
        <ProfessionalServiceForm
          initialService={data.professionalService}
          submitLabel="Save Changes"
          submitting={saving}
          onSubmit={handleSubmit}
          onCancel={() => navigate(`/sales/professional-services/${id}`)}
        />
      </div>
    </div>
  );
};

export default EditProfessionalService;
